import apiUrl from '../../../constants.js';
import axios from 'axios';
import VueElementLoading from 'vue-element-loading';
import CryptoJS from 'crypto-js';
import moment from 'moment';

export default {
  name: 'FmBagHandover',
  components: { VueElementLoading },

  data() {
    return {
      isLoading: false,
      bagListLoading: false, // Specific loader for the table area
      
      // Handover Logic
      handoverStarted: false,
      currentRequestId: null,
      currentStatus:null,
      currentHandoverId: null,
      
      // Counts
      totalBags: 0,
      scannedCount: 0, 

      // Data Containers
      handoverList: [],
      priorityData: {},
      
  
      bagList: {
        scanned: [],
        unscanned: [],
        shortage: []
      },

      // Selection States
      selectedPriority: null, // Stores currently active tab (e.g., "P0")
      scannedBagInput: "",
      
      // Modals
      showDetailsforRequestIdModal: false,

      // User Info
      userId: null,
      userHubId: null,
      createdBy: null,
      token: null,
      inputError: false,
      hubName: '',
      latitude: '',
      longitude: ''
    };
  },

  mounted() {
    this.decryptUserToken();
    

    this.getBagHandoverList();
  },

  filters: {
    moment: function(date) {
      if (date == null || date == '') return '--';
      return moment(date).format('DD-MM-YYYY HH:mm:ss');
    }
  },

  methods: {

    // ===============================
    // 1. USER TOKEN DECRYPTION
    // ===============================
    decryptUserToken() {
      try {
        const userTokenEncrypt = window.localStorage.getItem('userToken');
        const decryptedToken = CryptoJS.AES.decrypt(userTokenEncrypt.toString(), 'Key');
        this.token = JSON.parse(decryptedToken.toString(CryptoJS.enc.Utf8));

        const userdetailEncrypt = window.localStorage.getItem('userdetail');
        const bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
        const userdetail = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));

        const user = (userdetail && userdetail[0]) ? userdetail[0] : {};
        this.userHubId = Number((user.HubId && user.HubId[0]) ? user.HubId[0] : 0);
        this.userId = Number(user.userid ? user.userid : 0);
        this.createdBy = userdetail[0].email;
        this.getHubName(this.userHubId)
      } catch (e) {
        console.error("Error decrypting token", e);
      }
    },

    // ===============================
    // 2. FETCH MAIN LIST
    // ===============================
    getBagHandoverList() {
      this.isLoading = true;
      const input = { 
        hubId: this.userHubId, 
        userId: this.userId, 
        requestFrom: "Facility" 
      };

      axios.post(`${apiUrl.api_url_hubops}fmBagging/getHandoverRequestList`, input, {
        headers: { authorization: 'authkey xB84JJ89Hd25' }
      })
      .then(result => {
        this.isLoading = false;
        if (result.data.ResultCode === 100) {
          this.handoverList = result.data.ResponseData;
        } else if (result.data.ResultCode === 101) {
          this.handoverList = [];
        } else {
          this.$alertify.error(result.data.ReturnMessage);
        }
      })
      .catch(err => {
        this.$alertify.error(result.data.ReturnMessage);
        this.isLoading = false;
      });
    },

    // ===============================
    // 3. OPEN MODAL & GET DETAILS
    // ===============================
    openModal(row) {
      this.currentRequestId = row.handoverRequestBatchId;
      this.currentStatus = row.handoverRequestBatchStatus;
      this.handoverStarted = false;
      this.getHandoverDetails();
    },

    getHandoverDetails() {
      this.isLoading = true;
      this.scannedBagInput = "";
      this.selectedPriority = null; // Reset tab selection
      this.bagList = { scanned: [], unscanned: [], shortage: [] }; // Clear lists

      const input = {
        hubId: this.userHubId,
        userId: this.userId,
        handoverRequestBatchId: this.currentRequestId
      };

      axios.post(`${apiUrl.api_url_hubops}fmBagging/getHandoverDetails`, input, {
        headers: { authorization: 'authkey xB84JJ89Hd25' }
      })
      .then(result => {
        this.isLoading = false;
        if (result.data.ResultCode === 100) {
          const res = result.data.ResponseData;

          // Parse Total vs Scanned (e.g. "2/5")
          let scanned = 0;
          let total = 0;
          if (res.total && res.total.includes('/')) {
             const parts = res.total.split('/');
             scanned = parseInt(parts[0]) || 0;
             total = parseInt(parts[1]) || 0;
          }

          this.currentHandoverId = res.requestId;
          this.totalBags = total;
          this.scannedCount = scanned;

          // Store priority counts for Tabs (e.g. { P0: 1, P2: 4 })
          this.priorityData = res || { priorityCounts: {} };

          this.showDetailsforRequestIdModal = true;
        } else {
          this.$alertify.error(result.data.ReturnMessage);
        }
      })
      .catch(err => {
        this.$alertify.error(result.data.ReturnMessage);
        this.isLoading = false;
      });
    },

    // ===============================
    // 4. TAB SELECTION LOGIC
    // ===============================
    selectPriority(key) {
      this.selectedPriority = key;
      this.toggleBagList(key);
    },

    toggleBagList(priority) {
      this.bagListLoading = true;
      
      // Reset list momentarily while loading
      this.bagList = { scanned: [], unscanned: [], shortage: [] };

      const input = {
        userId:this.userId,
        hubId: this.userHubId,
        handOverRequestId: this.currentHandoverId,
        priorityType: priority
      };

      axios.post(`${apiUrl.api_url_hubops}fmBagging/getHandOverBagList`, input, {
        headers: {
          "Content-Type": "application/json",
          authorization: "authkey xB84JJ89Hd25"
        }
      })
      .then(res => {
        this.bagListLoading = false;
        if (res.data.ResultCode === 100) {
          // Access specific priority key in response
          const summary = res.data.ResponseData.bagSummary[priority] || {};
          
          this.bagList = {
            scanned: summary.scannedBags || [],
            unscanned: summary.unscannedBags || [],
            shortage: summary.shortageBags || []
          };
        } else {
          this.$alertify.error(res.data.ReturnMessage);
        }
      })
      .catch(() => {
        this.$alertify.error(result.data.ReturnMessage);
        this.bagListLoading = false;
        this.$alertify.error("Failed to load bag list");
      });
    },

    // ===============================
    // 5. SCANNING LOGIC
    // ===============================
    startHandover() {
      this.handoverStarted = true;
      // Focus the input field manually if needed
      this.$nextTick(() => {
        if(this.$refs.scanInput) this.$refs.scanInput.focus();
      });
    },

     getHubName(hubid) {
      this.input = {
        hubids: [hubid]
      }
      axios({
          method: 'POST',
          headers: {
            authorization : 'authkey xB84JJ89Hd25'
          },
          url: apiUrl.api_url_hubops + 'getHubServicecenterHubarray',
          data: this.input
        })
        .then(result => {
          if (result.data.code == 200) {
            this.hubName = result.data.data[0].HubName
            this.latitude = result.data.data[0].Latitude
            this.longitude = result.data.data[0].Longitude
          } else {
            this.hubName = '';
          }
          this.inputHub = {
            "Outsourceid":4,
            "hubid":this.userHubId
          }
          axios({
            method: 'POST',
            headers: {
              authorization : 'authkey xB84JJ89Hd25'
            },
            url: apiUrl.api_url_hubops + 'getHubFlags',
            data: this.inputHub
          })
          .then(result => {
            if (result.data.code==200) {
              this.isRSVSr = result.data.data.IsRSVSr
            } else {
              this.$alertify.error(result.data.message)
            }
          }, error => {
            console.error(error)
          })
        }, error => {
          console.error(error)
        })
    },

    scanBag() {
      const seal = this.scannedBagInput.trim();
      

      if (!seal) {
      this.inputError = true; 
      return; 
    }
    
    // 2. If valid, clear error and proceed
    this.inputError = false;

      const input = {
        hubId: this.userHubId,
        userId: this.userId,
        handoverRequestId: this.currentHandoverId,
        bagSealNumber: seal,
        requestFrom: "Executive",
        eventName: "FacilityBagScan",
        latitude: this.latitude || "",
        longitude: this.longitude || "",
        isExcess: false,
        status: "HandoverApprovalInProgress"
      };

      this.isLoading = true; // Use global loading for scan action
      
      axios.post(`${apiUrl.api_url_hubops}fmBagging/scanHandoverBag`, input, {
        headers: { authorization: 'authkey xB84JJ89Hd25' }
      })
      .then(res => {
        this.isLoading = false;
        if (res.data.ResultCode === 100) {
          this.$alertify.success(res.data.ReturnMessage);
          this.scannedBagInput = "";
          
          // Refresh Data:
          // 1. Refresh Header Counts
          this.getHandoverDetails(); 
          
          // 2. If a tab is open, refresh that list specifically
          if (this.selectedPriority) {
            this.toggleBagList(this.selectedPriority);
          }
        } 
        else {
          this.$alertify.error(res.data.ReturnMessage);
          this.resetScan();
        }
      })
      .catch(err => {
        this.$alertify.error(result.data.ReturnMessage);
        this.isLoading = false;
        
      });
    },

    // ===============================
    // 6. SHORTAGE LOGIC
    // ===============================
    markShortage(bagId,originalbagId) {
      if (!confirm(`Are you sure you want to mark bag "${bagId}" as shortage?`)) return;

      const input = {
        hubId: this.userHubId,
        userId: this.userId,
        shipmentIds: [],
        bagId: originalbagId,
        createdBy: this.createdBy,
        isSupervisor: false,
        eventName:"RaiseShortageRequest",
        latitude:this.latitude,
        longitude:this.longitude
      };

      axios.post(`${apiUrl.api_url_hubops}fmBagging/initiateORMarkFMShortage`, input, {
        headers: {
          Authorization: "authkey xB84JJ89Hd25",
          "Content-Type": "application/json"
        }
      })
      .then(res => {
        if (res.data.ResultCode === 100) {
          this.$alertify.success(`Bag "${bagId}" marked as shortage`);
          
          // Refresh list to move bag from Unscanned to Shortage
          if (this.selectedPriority) {
            this.toggleBagList(this.selectedPriority);
          }
          this.getHandoverDetails(); // Update counts if necessary
        } else {
          this.$alertify.error(res.data.ReturnMessage || "Failed to mark shortage");
        }
      })
      .catch(err => {
        this.$alertify.error(result.data.ReturnMessage);
        this.$alertify.error("API call failed for marking shortage");
      });
    },

    // ===============================
    // 7. APPROVAL LOGIC
    // ===============================
    isAllBagsScanned() {
      // Check if scanned count equals total bags
      return this.totalBags > 0 && this.scannedCount === this.totalBags;
    },

    approveHandover() {
      if (!this.isAllBagsScanned()) {
        this.$alertify.alert("Cannot Approve", "Please scan all bags before approving.");
        return;
      }

      const input = {
        hubId: this.userHubId,
        userId: this.userId,
        handoverRequestId: this.currentHandoverId,
        eventName: "ApproveHandoverByFacility",
        latitude: this.latitude,
        longitude: this.longitude
      };

      this.isLoading = true;
      axios.post(`${apiUrl.api_url_hubops}fmBagging/approveHandover`, input, {
        headers: { authorization: 'authkey xB84JJ89Hd25' }
      })
      .then(res => {
        this.isLoading = false;
        if (res.data.ResultCode === 100) {
          this.$alertify.success("Handover approved successfully");
          this.closeBagDetailModal();
          this.getBagHandoverList(); // Refresh main table
        } else {
          this.$alertify.error(res.data.ReturnMessage);
        }
      })
      .catch(err => {
         this.$alertify.error(res.data.ReturnMessage);
        this.isLoading = false;
       
      });
    },

    // ===============================
    // 8. HELPERS
    // ===============================
    closeBagDetailModal() {
      this.showDetailsforRequestIdModal = false;
      this.handoverStarted = false;
      this.scannedBagInput = "";
      this.currentRequestId = null;
      this.currentHandoverId = null;
      this.totalBags = 0;
      this.scannedCount = 0;
      this.priorityData = {};
      this.selectedPriority = null;
    },

    resetScan() {
    this.scannedBagInput = "";

    
    this.inputError = false;
    // Set focus back to input
    this.$nextTick(() => {
      if(this.$refs.scanInput) this.$refs.scanInput.focus();
    });
  },
  }
};


// WEBPACK FOOTER //
// ./src/views/components/FmBagHandover/FmBagHandover.js